import React, { useEffect, useState } from 'react';

import { ScrollTrackingBlockData } from 'api/cms';
import ScrollWatcherContainer from 'containers/ScrollWatcherContainer';
import { trackEvent } from 'utils/analytics';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ScrollTrackingBlock = ({
  data: { eventName },
}: {
  data: ScrollTrackingBlockData;
}) => {
  const [tracked, setTracked] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const onScroll = () => {
    if (!scrolled) {
      setScrolled(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  });
  return (
    <ScrollWatcherContainer>
      {({ isInViewport }) => {
        if (isInViewport && !tracked) {
          trackEvent(`Scroll: ${eventName}`, {
            reached_through: scrolled ? 'Scrolling' : 'Page Load',
          });
          setTracked(true);
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
      }}
    </ScrollWatcherContainer>
  );
};

// eslint-disable-next-line import/no-default-export
export default ScrollTrackingBlock;
